import React from 'react';
import dotAccess from 'dot-access';
import './OutputList.css';
import PropTypes from 'prop-types';
import getLabel from '../../translations/messages';

const getDisplayValue = (value, localize, locale) => (
  localize ? getLabel(locale, localize + '.' + value) : value
);

export const SimpleOutputList = ({ resource, name, localize }, { locale }) => {
  const values = dotAccess.get(resource, name);

  return (
    <span>
      {values ? values.map((v, i) => <div key={i}>{getDisplayValue(v, localize, locale)}</div>) : ''}
    </span>
  );
};

SimpleOutputList.contextTypes = {
  locale: PropTypes.string,
};

const OutputList = (props, context) => {
  const values = dotAccess.get(props.resource, props.name);

  return (
    <div className="OutputList">
      <div className="output-label">{getLabel(context.locale, props.label)}</div>
      <div className="list-container">
        {values ? values.map((v, i) => <div key={i}>{v}</div>) : ''}
      </div>
    </div>
  );
};

OutputList.contextTypes = {
  locale: PropTypes.string,
};

export default OutputList;



// WEBPACK FOOTER //
// ./src/main/components/output/OutputList.js